import { render, staticRenderFns } from "./CustomAppraiser.vue?vue&type=template&id=16f871c3&scoped=true&"
import script from "./CustomAppraiser.vue?vue&type=script&lang=js&"
export * from "./CustomAppraiser.vue?vue&type=script&lang=js&"
import style0 from "./CustomAppraiser.vue?vue&type=style&index=0&id=16f871c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f871c3",
  null
  
)

export default component.exports